import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { List, Datagrid, FilterForm } from 'components/list';
import { DateInput, AutocompleteInput, SelectInput } from 'components/input';
import { TextField } from 'components/field';

import { crudGetMeta as crudGetMetaAction } from 'actions/dataActions';

class AdminLogFilter extends Component {

  static propTypes = {
    userChoices: PropTypes.array.isRequired,
    contentTypeChoices: PropTypes.array.isRequired,
  };

  static defaultProps = {
    userChoices: [],
    contentTypeChoices: [],
  };

  render() {
    const { userChoices, contentTypeChoices } = this.props;

    return (
      <FilterForm name='admin_log_filter' {...this.props}>
        <DateInput source='start_time' label='Start' isRequired={true}/>
        <DateInput source='end_time' label='End' isRequired={true}/>
        <SelectInput source='content_type' label='Operation' choices={contentTypeChoices}/>
        <AutocompleteInput source='user' label='User' choices={userChoices}/>
      </FilterForm>
    );
  }

}

class AdminLogListBase extends Component {

  static propTypes = {
    crudGetMeta: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { resource, backendPath } = this.props;
    this.props.crudGetMeta(resource, backendPath, { meta: true });
  }

  render() {

    const { userChoices, contentTypeChoices } = this.props.meta;
    const filters = <AdminLogFilter userChoices={userChoices} contentTypeChoices={contentTypeChoices}/>;

    return (
      <List filters={filters} sort={{field: 'action_time', order: 'DESC'}} {...this.props}>
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source='action_time' label='Time'/>
          <TextField source='user' label='User'/>
          <TextField source='operation' label='Operation'/>
          <TextField source='action' label='Action'/>
          <TextField source='change_message' label='Detail'/>
        </Datagrid>
      </List>
    )
  }
}

export const AdminLogList = connect(
  (state, props) => ({
    meta: state.admin[props.resource].meta,
  }),
  { crudGetMeta: crudGetMetaAction },
)(AdminLogListBase);


// WEBPACK FOOTER //
// ./src/routes/user/AdminLogList.js